var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _ellipse, _path8, _mask2, _ellipse2, _path9, _mask3, _ellipse3, _path10, _mask4, _ellipse4, _path11, _mask5, _ellipse5, _path12, _mask6, _ellipse6, _path13, _mask7, _ellipse7, _path14, _mask8, _ellipse8, _path15, _mask9, _ellipse9, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackblueLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 34,
    viewBox: "0 0 115 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1777 2.63504L22.0053 1.29707C21.69 1.10284 21.3269 1 20.9565 1H18.9335C18.3812 1 17.9335 1.44772 17.9335 2V32C17.9335 32.5523 18.3812 33 18.9335 33H21.3193C21.5015 33 21.6802 32.9502 21.8362 32.856L24.8538 31.0338C25.1536 30.8528 25.3369 30.528 25.3369 30.1778V24.8637",
    stroke: "#25AAE5",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.055 29.7314L28.8594 28.6227C29.1555 28.4407 29.3359 28.1182 29.3359 27.7707V24.0477M21.4838 29.381V24.6095C21.4838 24.2606 21.6657 23.9369 21.9637 23.7554L25.4472 21.634",
    stroke: "#25AAE5",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.9092V21.6086C33 21.9621 32.8134 22.2893 32.5092 22.4693L30.2191 23.8243C29.9049 24.0102 29.5144 24.0101 29.2003 23.824L25.8626 21.8469C25.5587 21.6668 25.3723 21.3398 25.3723 20.9865V18.9092",
    stroke: "#25AAE5",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2331 11.3159L32.5087 12.6607C32.8132 12.8406 33 13.1679 33 13.5216V16.5164C33 16.8649 32.8186 17.1883 32.5212 17.3699L29.1114 19.4522",
    stroke: "#25AAE5",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9612 12.8325L28.8536 10.4771C29.153 10.2959 29.3359 9.97146 29.3359 9.62154V6.27702C29.3359 5.92443 29.1502 5.5979 28.8472 5.41762L26.1829 3.83251C25.8678 3.64505 25.4754 3.64505 25.1603 3.83251L21.4838 6.0198",
    stroke: "#25AAE5",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0055 7.69678L21.9653 10.1303C21.6649 10.3112 21.4812 10.6362 21.4812 10.9869V14.1934C21.4812 14.5566 21.6782 14.8913 21.9958 15.0677L24.8976 16.679C25.2126 16.8539 25.5973 16.8458 25.9046 16.6579L29.4828 14.4705",
    stroke: "#25AAE5",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1938 17.1958L21.8955 19.4148",
    stroke: "#25AAE5",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8975,
    cy: 19.4131,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8975,
    cy: 19.4131,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4818 19.4131C21.4818 19.2658 21.6115 19.0421 21.8975 19.0421V22.0421C23.3812 22.0421 24.4818 20.8075 24.4818 19.4131H21.4818ZM21.8975 19.0421C22.1835 19.0421 22.3132 19.2658 22.3132 19.4131H19.3132C19.3132 20.8075 20.4138 22.0421 21.8975 22.0421V19.0421ZM22.3132 19.4131C22.3132 19.5605 22.1835 19.7842 21.8975 19.7842V16.7842C20.4138 16.7842 19.3132 18.0188 19.3132 19.4131H22.3132ZM21.8975 19.7842C21.6115 19.7842 21.4818 19.5605 21.4818 19.4131H24.4818C24.4818 18.0188 23.3812 16.7842 21.8975 16.7842V19.7842Z",
    fill: "#25AAE5",
    mask: "url(#path-8-inside-1_624_7466)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-2_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3752,
    cy: 18.9073,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3752,
    cy: 18.9073,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9595 18.9073C24.9595 18.7599 25.0892 18.5362 25.3752 18.5362V21.5362C26.8589 21.5362 27.9595 20.3016 27.9595 18.9073H24.9595ZM25.3752 18.5362C25.6612 18.5362 25.7908 18.7599 25.7908 18.9073H22.7908C22.7908 20.3016 23.8914 21.5362 25.3752 21.5362V18.5362ZM25.7908 18.9073C25.7908 19.0546 25.6612 19.2783 25.3752 19.2783V16.2783C23.8914 16.2783 22.7908 17.5129 22.7908 18.9073H25.7908ZM25.3752 19.2783C25.0892 19.2783 24.9595 19.0546 24.9595 18.9073H27.9595C27.9595 17.5129 26.8589 16.2783 25.3752 16.2783V19.2783Z",
    fill: "#25AAE5",
    mask: "url(#path-10-inside-2_624_7466)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-3_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3389,
    cy: 24.8628,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3389,
    cy: 24.8628,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9232 24.8628C24.9232 24.7155 25.0529 24.4918 25.3389 24.4918V27.4918C26.8226 27.4918 27.9232 26.2572 27.9232 24.8628H24.9232ZM25.3389 24.4918C25.6249 24.4918 25.7546 24.7155 25.7546 24.8628H22.7546C22.7546 26.2572 23.8552 27.4918 25.3389 27.4918V24.4918ZM25.7546 24.8628C25.7546 25.0102 25.6249 25.2339 25.3389 25.2339V22.2339C23.8552 22.2339 22.7546 23.4685 22.7546 24.8628H25.7546ZM25.3389 25.2339C25.0529 25.2339 24.9232 25.0102 24.9232 24.8628H27.9232C27.9232 23.4685 26.8226 22.2339 25.3389 22.2339V25.2339Z",
    fill: "#25AAE5",
    mask: "url(#path-12-inside-3_624_7466)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-4_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4868,
    cy: 29.3804,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4868,
    cy: 29.3804,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0711 29.3804C21.0711 29.2331 21.2008 29.0094 21.4868 29.0094V32.0094C22.9705 32.0094 24.0711 30.7748 24.0711 29.3804H21.0711ZM21.4868 29.0094C21.7728 29.0094 21.9025 29.2331 21.9025 29.3804H18.9025C18.9025 30.7748 20.0031 32.0094 21.4868 32.0094V29.0094ZM21.9025 29.3804C21.9025 29.5278 21.7728 29.7515 21.4868 29.7515V26.7515C20.0031 26.7515 18.9025 27.9861 18.9025 29.3804H21.9025ZM21.4868 29.7515C21.2008 29.7515 21.0711 29.5278 21.0711 29.3804H24.0711C24.0711 27.9861 22.9705 26.7515 21.4868 26.7515V29.7515Z",
    fill: "#25AAE5",
    mask: "url(#path-14-inside-4_624_7466)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-5_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4868,
    cy: 6.02007,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4868,
    cy: 6.02007,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0711 6.02007C21.0711 5.87273 21.2008 5.64902 21.4868 5.64902V8.64902C22.9705 8.64902 24.0711 7.41441 24.0711 6.02007H21.0711ZM21.4868 5.64902C21.7728 5.64902 21.9025 5.87273 21.9025 6.02007H18.9025C18.9025 7.41441 20.0031 8.64902 21.4868 8.64902V5.64902ZM21.9025 6.02007C21.9025 6.1674 21.7728 6.39111 21.4868 6.39111V3.39111C20.0031 3.39111 18.9025 4.62573 18.9025 6.02007H21.9025ZM21.4868 6.39111C21.2008 6.39111 21.0711 6.1674 21.0711 6.02007H24.0711C24.0711 4.62573 22.9705 3.39111 21.4868 3.39111V6.39111Z",
    fill: "#25AAE5",
    mask: "url(#path-16-inside-5_624_7466)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-6_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0117,
    cy: 7.69487,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0117,
    cy: 7.69487,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.596 7.69487C25.596 7.54754 25.7257 7.32383 26.0117 7.32383V10.3238C27.4954 10.3238 28.596 9.08921 28.596 7.69487H25.596ZM26.0117 7.32383C26.2977 7.32383 26.4274 7.54754 26.4274 7.69487H23.4274C23.4274 9.08921 24.528 10.3238 26.0117 10.3238V7.32383ZM26.4274 7.69487C26.4274 7.84221 26.2977 8.06592 26.0117 8.06592V5.06592C24.528 5.06592 23.4274 6.30053 23.4274 7.69487H26.4274ZM26.0117 8.06592C25.7257 8.06592 25.596 7.84221 25.596 7.69487H28.596C28.596 6.30053 27.4954 5.06592 26.0117 5.06592V8.06592Z",
    fill: "#25AAE5",
    mask: "url(#path-18-inside-6_624_7466)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-7_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9646,
    cy: 12.8326,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9646,
    cy: 12.8326,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5489 12.8326C24.5489 12.6852 24.6786 12.4615 24.9646 12.4615V15.4615C26.4483 15.4615 27.5489 14.2269 27.5489 12.8326H24.5489ZM24.9646 12.4615C25.2506 12.4615 25.3802 12.6852 25.3802 12.8326H22.3802C22.3802 14.2269 23.4809 15.4615 24.9646 15.4615V12.4615ZM25.3802 12.8326C25.3802 12.9799 25.2506 13.2036 24.9646 13.2036V10.2036C23.4809 10.2036 22.3802 11.4382 22.3802 12.8326H25.3802ZM24.9646 13.2036C24.6786 13.2036 24.5489 12.9799 24.5489 12.8326H27.5489C27.5489 11.4382 26.4483 10.2036 24.9646 10.2036V13.2036Z",
    fill: "#25AAE5",
    mask: "url(#path-20-inside-7_624_7466)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-8_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1136,
    cy: 19.4505,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1136,
    cy: 19.4505,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6979 19.4505C28.6979 19.3032 28.8276 19.0794 29.1136 19.0794V22.0794C30.5973 22.0794 31.6979 20.8448 31.6979 19.4505H28.6979ZM29.1136 19.0794C29.3996 19.0794 29.5292 19.3032 29.5292 19.4505H26.5292C26.5292 20.8448 27.6298 22.0794 29.1136 22.0794V19.0794ZM29.5292 19.4505C29.5292 19.5978 29.3996 19.8215 29.1136 19.8215V16.8215C27.6298 16.8215 26.5292 18.0561 26.5292 19.4505H29.5292ZM29.1136 19.8215C28.8276 19.8215 28.6979 19.5978 28.6979 19.4505H31.6979C31.6979 18.0561 30.5973 16.8215 29.1136 16.8215V19.8215Z",
    fill: "#25AAE5",
    mask: "url(#path-22-inside-8_624_7466)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-9_624_7466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.4879,
    cy: 14.4698,
    rx: 1.08433,
    ry: 1.12895
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.4879,
    cy: 14.4698,
    rx: 1.08433,
    ry: 1.12895,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0722 14.4698C29.0722 14.3224 29.2019 14.0987 29.4879 14.0987V17.0987C30.9716 17.0987 32.0722 15.8641 32.0722 14.4698H29.0722ZM29.4879 14.0987C29.7739 14.0987 29.9036 14.3224 29.9036 14.4698H26.9036C26.9036 15.8641 28.0042 17.0987 29.4879 17.0987V14.0987ZM29.9036 14.4698C29.9036 14.6171 29.7739 14.8408 29.4879 14.8408V11.8408C28.0042 11.8408 26.9036 13.0754 26.9036 14.4698H29.9036ZM29.4879 14.8408C29.2019 14.8408 29.0722 14.6171 29.0722 14.4698H32.0722C32.0722 13.0754 30.9716 11.8408 29.4879 11.8408V14.8408Z",
    fill: "#25AAE5",
    mask: "url(#path-24-inside-9_624_7466)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82525 2.63504L12.2388 1.14854C12.3965 1.05142 12.578 1 12.7632 1H15.0695C15.6218 1 16.0695 1.44772 16.0695 2V31C16.0695 32.1046 15.1741 33 14.0695 33H12.6837C12.5015 33 12.3228 32.9502 12.1668 32.856L9.14921 31.0338C8.84938 30.8528 8.66614 30.528 8.66614 30.1778V24.8637",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94642 29.7314L5.14207 28.6227C4.84599 28.4407 4.66559 28.1182 4.66559 27.7707V24.0477M12.5176 29.381V24.6095C12.5176 24.2606 12.3358 23.9369 12.0378 23.7554L8.55422 21.634",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.9076V21.607C1 21.9605 1.18659 22.2877 1.49078 22.4677L3.78086 23.8227C4.09507 24.0086 4.48563 24.0085 4.79975 23.8224L8.13736 21.8452C8.44131 21.6652 8.6277 21.3381 8.6277 20.9849V18.8687",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76691 11.3159L1.49126 12.6607C1.18679 12.8406 1 13.1679 1 13.5216V16.5164C1 16.8649 1.18141 17.1883 1.47882 17.3699L4.88863 19.4522",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0403 12.8325L5.14788 10.4771C4.8485 10.2959 4.66559 9.97146 4.66559 9.62154V6.27702C4.66559 5.92443 4.85127 5.5979 5.15429 5.41762L7.81858 3.83251C8.13367 3.64505 8.52608 3.64505 8.84117 3.83251L12.5176 6.0198",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99448 7.69678L12.0347 10.1303C12.3351 10.3112 12.5188 10.6362 12.5188 10.9869V14.1934C12.5188 14.5566 12.3218 14.8913 12.0042 15.0677L9.10239 16.679C8.78743 16.8539 8.40273 16.8458 8.09535 16.6579L4.51715 14.4705",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 17.1958L12.103 19.4148",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.161 10H113.078V12.3822H110.161V10ZM108.747 21.1598H110.487V16.1571H108.747V13.9398H113.042V21.1598H114.6V23.3771H108.747V21.1598Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.955 23.6521C100.989 23.6521 100.221 23.2367 99.6537 22.406C99.0859 21.5752 98.802 20.4452 98.802 19.0159C98.802 17.2811 99.2369 15.9617 100.107 15.0577C100.976 14.1415 102.227 13.6833 103.858 13.6833C104.776 13.6833 105.851 13.8299 107.083 14.1231V23.3772H104.655L104.709 21.8746H104.637C104.323 22.4487 103.936 22.8885 103.477 23.1939C103.03 23.4994 102.523 23.6521 101.955 23.6521ZM102.499 21.3981C102.873 21.3981 103.242 21.1965 103.604 20.7934C103.966 20.3902 104.305 19.8527 104.619 19.1808V16.1022C104.232 15.9923 103.846 15.9373 103.459 15.9373C102.734 15.9373 102.185 16.1877 101.81 16.6886C101.448 17.1895 101.266 17.9286 101.266 18.9059C101.266 19.6756 101.375 20.2864 101.593 20.7384C101.81 21.1782 102.112 21.3981 102.499 21.3981Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3959 24C94.8885 24 94.4475 23.8107 94.073 23.432C93.7106 23.0655 93.5294 22.6257 93.5294 22.1126C93.5294 21.5873 93.7106 21.1414 94.073 20.7749C94.4475 20.3961 94.8885 20.2068 95.3959 20.2068C95.9153 20.2068 96.3563 20.3961 96.7187 20.7749C97.0811 21.1414 97.2623 21.5873 97.2623 22.1126C97.2623 22.6257 97.0811 23.0655 96.7187 23.432C96.3563 23.8107 95.9153 24 95.3959 24Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.806 13.9399H85.3067V15.5708C85.6933 14.9233 86.1402 14.4469 86.6476 14.1415C87.155 13.8361 87.7469 13.6833 88.4235 13.6833C89.4261 13.6833 90.2114 13.9888 90.7791 14.5996C91.3469 15.1982 91.6308 16.035 91.6308 17.1101V23.3772H89.0758V17.5132C89.0758 17.0246 88.955 16.6459 88.7134 16.3771C88.4718 16.0961 88.1456 15.9556 87.7349 15.9556C87.2516 15.9556 86.7926 16.1389 86.3577 16.5054C85.9228 16.8719 85.5906 17.3361 85.3611 17.8981V23.3772H82.806V13.9399Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5675 23.6521C74.6011 23.6521 73.8339 23.2367 73.2662 22.406C72.6984 21.5752 72.4145 20.4452 72.4145 19.0159C72.4145 17.2811 72.8494 15.9617 73.7192 15.0577C74.589 14.1415 75.8393 13.6833 77.4702 13.6833C78.3883 13.6833 79.4634 13.8299 80.6957 14.1231V23.3772H78.2675L78.3218 21.8746H78.2494C77.9353 22.4487 77.5487 22.8885 77.0896 23.1939C76.6427 23.4994 76.1353 23.6521 75.5675 23.6521ZM76.1111 21.3981C76.4856 21.3981 76.8541 21.1965 77.2165 20.7934C77.5789 20.3902 77.9171 19.8527 78.2312 19.1808V16.1022C77.8447 15.9923 77.4581 15.9373 77.0715 15.9373C76.3467 15.9373 75.797 16.1877 75.4225 16.6886C75.0601 17.1895 74.8789 17.9286 74.8789 18.9059C74.8789 19.6756 74.9876 20.2864 75.2051 20.7384C75.4225 21.1782 75.7245 21.3981 76.1111 21.3981Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5181 23.6521C65.5758 23.6521 64.7422 23.4444 64.0174 23.029C63.3047 22.6137 62.749 22.0334 62.3503 21.2882C61.9516 20.5307 61.7523 19.6572 61.7523 18.6677C61.7523 17.6782 61.9456 16.8108 62.3322 16.0656C62.7308 15.3082 63.2865 14.7218 63.9993 14.3064C64.7241 13.891 65.5577 13.6833 66.4999 13.6833C67.4422 13.6833 68.2697 13.891 68.9825 14.3064C69.7073 14.7095 70.263 15.2837 70.6496 16.0289C71.0482 16.7741 71.2476 17.6354 71.2476 18.6127C71.2476 19.6023 71.0482 20.4819 70.6496 21.2515C70.263 22.0089 69.7073 22.6014 68.9825 23.029C68.2697 23.4444 67.4483 23.6521 66.5181 23.6521ZM66.4999 21.4164C67.1523 21.4164 67.6717 21.166 68.0583 20.6651C68.457 20.152 68.6563 19.4801 68.6563 18.6494C68.6563 17.8187 68.457 17.159 68.0583 16.6703C67.6717 16.1694 67.1523 15.919 66.4999 15.919C65.8476 15.919 65.3221 16.1694 64.9234 16.6703C64.5369 17.159 64.3436 17.8187 64.3436 18.6494C64.3436 19.4801 64.5369 20.152 64.9234 20.6651C65.3221 21.166 65.8476 21.4164 66.4999 21.4164Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2449 21.1598H56.8939V12.199H55.3355V10H59.4489V21.1598H61.0979V23.3771H55.2449V21.1598Z",
    fill: "#25AAE5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6694 21.1598H50.3184V12.199H48.76V10H52.8734V21.1598H54.5224V23.3771H48.6694V21.1598Z",
    fill: "#25AAE5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.153 23.6521C41.1866 23.6521 40.4195 23.2367 39.8517 22.406C39.2839 21.5752 39 20.4452 39 19.0159C39 17.2811 39.4349 15.9617 40.3047 15.0577C41.1745 14.1415 42.4248 13.6833 44.0557 13.6833C44.9738 13.6833 46.049 13.8299 47.2812 14.1231V23.3772H44.853L44.9073 21.8746H44.8349C44.5208 22.4487 44.1342 22.8885 43.6751 23.1939C43.2282 23.4994 42.7208 23.6521 42.153 23.6521ZM42.6966 21.3981C43.0711 21.3981 43.4396 21.1965 43.802 20.7934C44.1644 20.3902 44.5027 19.8527 44.8167 19.1808V16.1022C44.4302 15.9923 44.0436 15.9373 43.657 15.9373C42.9322 15.9373 42.3825 16.1877 42.008 16.6886C41.6456 17.1895 41.4644 17.9286 41.4644 18.9059C41.4644 19.6756 41.5731 20.2864 41.7906 20.7384C42.008 21.1782 42.31 21.3981 42.6966 21.3981Z",
    fill: "#25AAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackblueLogo);
export default __webpack_public_path__ + "static/media/blackblueLogo.e0b4329ec1e5eee6ced2d4fb0ca4ee6f.svg";
export { ForwardRef as ReactComponent };